import { GetDaichouInfoRes } from "@/types/YuukyuuKanri";
import { reactive, ref } from "vue";

export interface FuyoSyuuseiData {
  before: {
    fuyoDays: number,
    tokubetsuKyuukaDays: number,
    this_year_fuyo_date: string | null
  },
  after: {
    fuyoDays: string,
    tokubetsuKyuukaDays: string,
    this_year_fuyo_date: string | null
  }
}

export function useFuyoSyuuseiModal() {
  const fuyoSyuuseiModalRef = ref()
  const syuuseiData: FuyoSyuuseiData = reactive({
    before: {
      fuyoDays: 0,
      tokubetsuKyuukaDays: 0,
      this_year_fuyo_date: null,
    },
    after: {
      fuyoDays: '0',
      tokubetsuKyuukaDays: '0',
      this_year_fuyo_date: null,
    }
  })

  const setData = async (syuuseiTarget: GetDaichouInfoRes | null) => {
    if (!syuuseiTarget) {
      return
    }
    syuuseiData.before.fuyoDays = Number(syuuseiTarget.konnen_fuyo_days)
    syuuseiData.before.tokubetsuKyuukaDays = Number(syuuseiTarget.tokubetsu_kyuuka)
    syuuseiData.before.this_year_fuyo_date = syuuseiTarget.this_year_fuyo_date

    syuuseiData.after.fuyoDays = syuuseiData.before.fuyoDays.toString()
    syuuseiData.after.tokubetsuKyuukaDays = syuuseiData.before.tokubetsuKyuukaDays.toString()
    syuuseiData.after.this_year_fuyo_date = syuuseiTarget.this_year_fuyo_date
  }

  const clearData = async () => {
    syuuseiData.before.fuyoDays = 0
    syuuseiData.before.tokubetsuKyuukaDays = 0
    syuuseiData.before.this_year_fuyo_date = null

    syuuseiData.after.fuyoDays = '0'
    syuuseiData.after.tokubetsuKyuukaDays = '0'
    syuuseiData.after.this_year_fuyo_date = null
  }

  const fuyoSyuuseiModalParts = reactive({
    title: '今年度付与日数の変更',
    button: ''
  })

  const openFuyoSyuuseiModal = () => {
    fuyoSyuuseiModalRef.value.open()
  }

  const closeFuyoSyuuseiModal = () => {
    fuyoSyuuseiModalRef.value.close()
  }

  return {
    fuyoSyuuseiModalRef,
    fuyoSyuuseiModalParts,
    openFuyoSyuuseiModal,
    closeFuyoSyuuseiModal,
    syuuseiData,
    setData,
    clearData
  }
}
